// extracted by mini-css-extract-plugin
export var border = "_1j-8";
export var brand = "_1j-t";
export var button = "_1j-l";
export var center = "_1j-a";
export var centered = "_1j-6";
export var closeButton = "_1j-c";
export var disabledWrapper = "_1j-m";
export var error = "_1j-p";
export var extraLarge = "_1j-4";
export var extraSmall = "_1j-1";
export var fill = "_1j-i";
export var footer = "_1j-h";
export var footerAction = "_1j-j";
export var footerButtons = "_1j-k";
export var header = "_1j-7";
export var headerWithClose = "_1j-d";
export var icon = "_1j-o";
export var info = "_1j-s";
export var inline = "_1j-9";
export var large = "_1j-3";
export var main = "_1j-e";
export var modal = "_1j-0";
export var nearFull = "_1j-5";
export var neutral = "_1j-u";
export var noPadding = "_1j-g";
export var none = "_1j-v";
export var scrollable = "_1j-f";
export var small = "_1j-2";
export var success = "_1j-r";
export var tight = "_1j-n";
export var titleIcon = "_1j-b";
export var warn = "_1j-q";